module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "id_Toc180483609",
      "lang": "en"
    }
  }, [_vm._v("5"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Athens")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Could this be Athens?")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("It was a pile of nothing. Broken marble bits and rotting plaster, graffiti everywhere, and all that plywood trying to pretend there was something interesting behind it. It didn’t fool anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("If it was discretion, it failed utterly. The boards themselves had slipped sideways. They leaned at an angle. They let us view the ugly truth between the cracks.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("My table was up against a long wall. Just around the corner was ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("the Tower of the Winds")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" with its sculpted figures circulating under the roof, each one puffing away to tell us about whatever its wind might bring—rain, dryness or good weather. They all had names. Much later, Anna told me the names of some; Yorgo, the names of others; and Elias, none at all. They each had their special moment, too: early morning, midday, evening when the sun went down. Alfie called them all zephyrs, but he was a classical man, and the wind he was talking about was the wind of a windbag: the wind coming from his ancestor’s memoirs, the wind that came rushing out and drove a ship right back to where it came from.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("From where I was seated, I could see people in twos or threes, wandering below this beautiful tower. They give it humanity, even though it dated from a couple of thousand years ago. It looked cared for, one of Athens’ treasures. Then, my eye wandered in the other direction: an abandoned building that took a lot of space. It was a big hulking mass, a rhinoceros among the gazelles, a mosque, a cautionary reminder of all that was cursed. It was a memory of centuries of fear before the final shove and the Ottomans.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("The bailout was not a glorious event. Far from it; it was a shame. There was no hiding the decrepitude of the many abandoned houses even here in proud Plaka bustling with people from all over the world. It was a show. It was a fine place with or without such traces. It was alive.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("There were the crowded taverns, the souvlaki joints and the little hotels. But in between, there were whiffs of abandonment. In all honesty, it seemed more ruinous than I could remember. Screaming faces scrawled their garish colors and political slogans in wild graffiti wherever they could. They were barely beaten back from hallowed monuments. Those images reveled in abandoned houses. They crawled around the windows, exploded across empty walls: they were everywhere. Sullen youths in torn jeans with equally sullen girls in even more torn jeans were sitting on wide steps to nowhere, sitting and smoking, but not here in the tourist runs: they were away from where the money tinkled.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Were these abandoned corners deliberately left to themselves, rubbish shamelessly accumulating, bricks tumbling from shaky walls to fill old doorways, weeds finding their way to survive in damp corners? Was it a demonstration: a lesson of life?")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("What was this lesson? That we died and we lived, and we lived and we died, wave upon wave. And we must ride the wave. Ride our wave. Ride it and ride it hard. And then the wave would enter into the great nothingness of water, or sea, or mystery, or darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("And we were gone.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("It was then that I started to make the connection. Decrepitude was a sign. It was a cautionary sign, a memory of a ghost that had been exorcised. It served as a reminder. Certain things, visible to all, were kept alive as a blind spot, a memory that one did not want to remember yet must not be forgotten. It was in the DNA. It worked equally for the bailout, for the Ottomans, for the Crusaders, even for the Persians. Everywhere were bits and pieces left behind, reminders.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Somehow, as I sat there below the Acropolis, my thoughts went to the letter K. I turned the various angles of the letter K in my mind as if it was a child’s playing block. Then, I saw three matchsticks falling on a table. They just fell there. One was upright, while another stuck out at an angle like the branch of a tree, and the third one propped up the branch just in case…in case of what? The support itself might fail and the tree would fall over. I didn’t know. But just as I stood in front of the adoption register in the office on Park Avenue, I happened to be standing in the right place at the right moment. So, I saw it. I saw the K. I was standing in the right place, and as I stood, each stick broke into three parts, and the parts became another K. So, that made three Ks. But not that KKK, no; not that mess.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I had been reading Kafka’s encounter with the new world, at least as he imagined it. America with a K. Didn’t he call his hero Josef K in ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("The Trial")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("? And in ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("The Castle,")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" it was just plain K. There was no coincidence.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I came to the conclusion that, for Kafka, the letter K was himself, seen from deep inside. The letter K conveyed that it was all real in the same way Kafka was real. ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("The Trial")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" was his trial. ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("The Castle ")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("was his castle. ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Amerika")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(" was his America.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("And Kokolakis?")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I breathed deeply. The air was scented with jasmine blossoms. It was spring. The lights on the Acropolis twinkled. I was in Greece. The plane had flown and dumped me here. It was miraculous. I felt very free. I beckoned to the waiter.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("‘Another ouzo please.’ I remembered looking at the family album of photos and bringing it to my mother’s attention that there were photos of my brothers and sisters when they were babies, but I didn’t see any of me. She pulled me close to her and whispered, ‘That’s because you are adopted.’")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("‘Adopted? What do you mean? What’s that got to do with me?’ I looked at her, barely understanding the horror. Then I understood.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("The waiter dodged between the people and cats and cars and landed my ouzo unscathed on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "sv"
    }
  }, [_vm._v("‘Kala?’")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "sv"
    }
  }, [_vm._v("‘Poli kala, thanks.’")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("After that, I could not help thinking of myself differently. I looked at my brothers and sisters. They looked different. They thought in a different way. I noticed they echoed my parents more faithfully. Don’t get me wrong, I loved my parents, and they were very good to me, kind and affectionate. But I started to wonder who I really was.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("‘Did I have a name? I mean from before?’ I asked my mother.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("‘No,’ she said. ‘There was nothing before. We were the first to give you your name. ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Michael")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(". I hope you like it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("‘Oh, I do. I do. It’s a nice name.’ I lied. I didn’t know what to say.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("It was just a name. But my mother was a person I loved. I was still young. Anyway, I didn’t want to displease her. What had all this got to do with me? I was not around.")]), _vm._v(" "), _c('p', {
    staticClass: "block_12",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Apparently.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Now in Greece, I felt free. I felt I could explore my name. I could play with it. M for Michael. My name was a child’s cube just like the letter K. It could be turned around and viewed from different angles. It could be the structure of a little house with diagonal supports in which I could hide. Or a house in which I could be entirely myself. Or entirely not myself.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Here, nobody knew my name. In Greece, Michael could be ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Mihaelis")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(", maybe ")]), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Mikelaki")]), _c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("And who would care, anyway? I could be anyone. I could be someone just passing through. I could invent a name, and no one would care.")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("I could become my name.")]), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Kafka’s K gave me a strange sensation. I looked at all these abandoned buildings, as if they, too, had a sort of ambiguous identity. So, K was a cipher, a sort of signature.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Koukouraki? That was an owl. The emblem of Athens.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Koukaki? That was a place. A quarter of the city of Athens.")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Kokolakis? That was a family that Christos remembered, a family who had suddenly and mysteriously left everything. Could it be me?")]), _vm._v(" "), _c('p', {
    staticClass: "block_11",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("So, Kokolakis was the name of a real person, or rather a real family, and there were probably any number of persons with this name, but was it also a sign for something unknown that had disappeared? Not so unknown. According to Christos’ memory, they knew how to speak to children. At least, they knew children liked chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4",
    attrs: {
      "id": "calibre_pb_8",
      "lang": "en"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b1df142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_008.vue
// module id = 87
// module chunks = 0